import ElThTree from './ElThTree.vue'
ElThTree.install = Vue => Vue.component(ElThTree.name, ElThTree)
export default ElThTree



// WEBPACK FOOTER //
// ./src/packages/elthtree/index.js